export { default as ProductTagEditTemplate } from './ProductTagEditTemplate';
export { default as ProductTagListTemplate } from './ProductTagListTemplate';
